import {
  type ApiClient,
  QuarkExperiences,
  RefDesignations,
} from '@prismo-io/schemas';
import { z } from 'zod';

const QuarkExperiencesArray = z.array(
  QuarkExperiences.merge(
    z.object({
      designation: RefDesignations.pick({ name: true }).nullable(),
      favorite: z.number().nullable(),
    })
  )
);

export const fetchExperiences = async (client: ApiClient, userId: string) => {
  // const {
  //   data: { session },
  // } = await client.auth.getSession();

  // if (!session) {
  //   throw new Error('You must be connected');
  // }

  const { data: experiences } = await client
    .from('quark_experiences')
    .select('*, designation:ref_designations(name)')
    .eq('user_id', userId)
    .order('favorite', { nullsFirst: false })
    .order('end_at', { ascending: false, nullsFirst: true })
    .order('start_at', { ascending: false, nullsFirst: false })
    .throwOnError();

  return QuarkExperiencesArray.parse(experiences);
};
